import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

// Attendre que le DOM soit chargé
document.addEventListener('DOMContentLoaded', function() {
    const testimonialsElement = document.querySelector('#testimonials .swiper');

    if (testimonialsElement) {
        const testimonialsSwiperInit = new Swiper(testimonialsElement, {
            modules: [Pagination, Autoplay],
            slidesPerView: 1.4,
            spaceBetween: 20,
            loop: true,
            // autoplay: {
            //     delay: 1000,
            //     disableOnInteraction: false,
            // },
            pagination: {
                el: '#testimonials .swiper-pagination'
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1440: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            }
        });
    }
});